import { Flex } from 'native-base';

import { PageScaffold } from '~/components/Layouts/Scaffolds/PageScaffold';
import { NavBar } from '~/components/NavBar';
import { RootPortal } from '~/components/RootPortal';
import { PreferencesModal } from '~/components/v2/ModalTemplates/PreferencesModal';
import { useEnablePreferencesModal } from '~/hooks/useUserPreferences/useEnablePreferencesModal';

export const AuthLayout = ({
  hideBackButton = false,
  hideMobileNavBar = false,
  children,
}: {
  hideBackButton?: boolean;
  hideWebSideBar?: boolean;
  isMobileBordered?: boolean;
  hideMobileNavBar?: boolean;
  children: JSX.Element | JSX.Element[];
}) => {
  const { modalRef: preferencesModalRef, onPressButton } =
    useEnablePreferencesModal();

  return (
    <Flex flex={1} bg={'gray.100'} minH={'100vh'}>
      <NavBar
        hideBackButton={hideBackButton}
        hideMobileNavBar={hideMobileNavBar}
      />

      <PageScaffold>{children}</PageScaffold>

      <RootPortal>
        <PreferencesModal
          onPressButton={onPressButton}
          modalRef={preferencesModalRef}
        />
      </RootPortal>
    </Flex>
  );
};
